export default __webpack_public_path__ + "assets/grid-view.24653c8c.svg";